import React from 'react'
import MainContentSubAccessories from '../MainContentSubAccessories'

const ProtectorScreenSub = () => {
  return (
    <div className='pageAccessories bg-accessories-sub-page'>
        <MainContentSubAccessories parentCate={'Phụ kiện'}  
            childCate={'Miếng dán màn hình'} 
            // listProduct={listProductSub}
    />
</div>
  )
}

export default ProtectorScreenSub
